export default {
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    REFRESH_TOKEN_REQUEST: 'REFRESH_TOKEN_REQUEST',
    REFRESH_TOKEN_SUCCESS: 'REFRESH_TOKEN_SUCCESS',
    REFRESH_TOKEN_FAILURE: 'REFRESH_TOKEN_FAILURE',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    SAVE_REFRESH_TOKEN_TIMER: 'SAVE_REFRESH_TOKEN_TIMER',
    SET_THEME: 'SET_THEME' 
}